import { render, staticRenderFns } from "./LawMatterSubSubjectForm.vue?vue&type=template&id=4c70976f&"
import script from "./LawMatterSubSubjectForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterSubSubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterSubSubjectForm.vue?vue&type=style&index=0&id=4c70976f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports